import React from 'react';
import { connect } from 'react-redux';

class Q_2 extends React.Component {
    constructor(props) {
        super(props);

        this.gotoNextStep = this.gotoNextStep.bind(this);
    }

    gotoNextStep(e) {
        e.preventDefault();

        this.props.nextStep(e.target.dataset['next'] || null, e.target.dataset['reason'] || null);
    }

    render() {
        return (
            <div className="click2call--groups">
                {this.props.call.registration.categoryOffline && (
                    <div className="click2call--group click2call--group-label">
                        <p className="click2call--content-offline">{this.props.call.registration.categoryOfflineDescription}</p>
                    </div>
                )}
                <div className="click2call--group click2call--group-label">
                    <p>Aby połączyć się z doradcą zaloguj się loginem i hasłem.</p>
                </div>
                <div className="click2call--group">
                    <div className="click2call--content-choice">
                        <button onClick={this.gotoNextStep} data-reason="Cancel">Anuluj</button>
                        <button className="login" onClick={this.gotoNextStep} data-reason="Login">Zaloguj</button>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        call: state.call
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch: dispatch
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Q_2);
